/* Action Types */
export const LOAD_HOME_DATA_FAIL = 'la/domain/home/LOAD_FAIL';
export const LOAD_HOME_DATA_REQUEST = 'la/domain/home/LOAD_REQUEST';
export const LOAD_HOME_DATA_SUCCESS = 'la/domain/home/LOAD_SUCCESS';
